module.exports = {
  "country": "SI",
  "artist": "Joker Out",
  "song": "Carpe diem",
  "year": "2023",
  "place": "21",
  "spotify": "14ibwN44PVKuvEqLiaNkKu"
};